export default function useCountHtmlTagCharacters() {
  const countHtmlTagCharacters = (input: string): number => {
    // Wyrażenie regularne do znalezienia wszystkich znaczników HTML
    const regex = /<[^>]*>/g;
    // Znajdowanie wszystkich dopasowań znaczników HTML
    const inputSmall = input.slice(0, 260);
    const matches = inputSmall.match(regex);
    // Jeśli brak dopasowań, zwróć 0
    if (!matches) {
      return 0;
    }
    // Zsumowanie długości wszystkich dopasowanych znaczników HTML
    const totalLength = matches.reduce((sum, tag) => sum + tag.length, 0);
    return totalLength;
  };

  return {
    countHtmlTagCharacters,
  };
}
